// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__hcW6b","button":"Notification_button__YfESP","primary":"Notification_primary__D7s7k"};